export default __webpack_public_path__ + "static/media/Blacksulphur Cowl.52e06ce2.jpg";